import { render, staticRenderFns } from "./UserAccountBillingHistory.vue?vue&type=template&id=ed1d798c&"
import script from "./UserAccountBillingHistory.vue?vue&type=script&lang=js&"
export * from "./UserAccountBillingHistory.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountBillingHistory.vue?vue&type=style&index=0&id=ed1d798c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports